import { render } from "./DocumentFieldConfigEditor.vue?vue&type=template&id=6d703047&ts=true"
import script from "./DocumentFieldConfigEditor.vue?vue&type=script&lang=ts"
export * from "./DocumentFieldConfigEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__